import { Component, computed, inject, output } from '@angular/core';
import { NotificationService } from '../../shared/services/notification.service';

@Component({
  selector: 'app-notification-dialog',
  standalone: true,
  templateUrl: './notification-dialog.component.html',
})
export class NotificationDialogComponent {
  private readonly notificationService = inject(NotificationService);

  dismiss = output<void>();
  enable = output<void>();

  readonly isDenied = computed(() => 
    this.notificationService.notificationPermission() === 'denied'
  );

  onDismiss(): void {
    this.dismiss.emit();
  }

  onEnable(): void {
    this.enable.emit();
  }
}
